<template>
	<!-- 用户维护 -->
	<div class="page-container" id="userMaintainContainer">
		<el-form :model="userMaintainForm" :rules="userMaintainFormRules" ref="userMaintainForm" class="form-panel" label-position="top">
			<el-col :span="24">
				<el-row class="content-panel">
                    <el-col>
                        <el-row>
                            <el-col>
                                <el-button type="primary" size="small" plain @click="handleAdd">新增用户</el-button>
                                <el-button type="primary" size="small" plain @click="handleSave">保存</el-button>
                                <el-button type="primary" size="small" plain @click="handleResetPwd">重置密码</el-button>
                                <el-button type="primary" size="small" plain @click="handleEnable">生效</el-button>
                                <el-button type="primary" size="small" plain @click="handleDisable">失效</el-button>
                            </el-col>
                        </el-row>
                    </el-col>
					<el-col>
						<el-row :gutter="22">
							<el-col :span="5">
								<el-form-item label="登陆账号" prop="user_code">
									<el-input size="mini" v-model="userMaintainForm.user_code"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="5">
								<el-form-item label="中文名称" prop="user_name_cn">
									<el-input size="mini" v-model="userMaintainForm.user_name_cn"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="5">
								<el-form-item label="用户类型" prop="user_type">
                                    <el-select class="length_input" size="mini" v-model="userMaintainForm.user_type"
                                        placeholder="请选择">
                                        <el-option
                                        v-for="item in userTypeList"
                                        :key="item.key"
                                        :label="item.value"
                                        :value="item.key"
                                        >
                                        </el-option>
                                    </el-select>
								</el-form-item>
							</el-col>
							<el-col :span="5">
								<el-form-item label="性别" prop="sex">
                                    <el-select class="length_input" size="mini" v-model="userMaintainForm.sex"
                                        placeholder="请选择">
                                        <el-option
                                        v-for="item in sexList"
                                        :key="item.key"
                                        :label="item.value"
                                        :value="item.key"
                                        >
                                        </el-option>
                                    </el-select>
								</el-form-item>
							</el-col>
							<el-col :span="4">
								<el-form-item label="英文名称">
									<el-input size="mini" v-model="userMaintainForm.user_name"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
                        <el-row :gutter="22">
							<el-col :span="5">
								<el-form-item label="电子邮箱" prop="email">
									<el-input size="mini" v-model="userMaintainForm.email"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="5">
								<el-form-item label="手机号">
									<el-input size="mini" v-model="userMaintainForm.mobile_phone"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="5">
								<el-form-item label="办公电话">
									<el-input size="mini" v-model="userMaintainForm.tel"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="5">
								<el-form-item label="传真">
									<el-input size="mini" v-model="userMaintainForm.fax"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="4">
								<el-form-item label="微信号">
									<el-input size="mini" v-model="userMaintainForm.wechat"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
                        <el-row :gutter="22">
							<el-col :span="5">
								<el-form-item label="QQ号码">
									<el-input size="mini" v-model="userMaintainForm.qq"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="5">
								<el-form-item label="身份证号" prop="identity_card_no">
									<el-input size="mini" v-model="userMaintainForm.identity_card_no"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="5">
								<el-form-item label="数据权限" prop="dataPermission">
									<el-input size="mini" v-model="userMaintainForm.dataPermission"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="4">
								<el-form-item label="状态">
									<el-input size="mini" v-model="userMaintainForm.is_active"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
                        <el-row :gutter="22">
							<el-col :span="5">
								<el-form-item label="生效时间">
                                    <el-date-picker
                                        v-model="userMaintainForm.active_start_time"
                                        type="date"
                                        size="mini"
                                        placeholder="选择日期">
                                    </el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="5">
								<el-form-item label="失效时间">
                                    <el-date-picker
                                        v-model="userMaintainForm.active_start_time"
                                        type="date"
                                        size="mini"
                                        placeholder="选择日期">
                                    </el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="5">
								<el-form-item label="用户来源">
									<el-input size="mini" v-model="userMaintainForm.user_source"></el-input>
								</el-form-item>
							</el-col>
                            <el-col :span="9">
								<el-form-item label="备注">
									<el-input size="mini" v-model="userMaintainForm.remark"></el-input>
								</el-form-item>
							</el-col>
						</el-row>
					</el-col>
				</el-row>
                <el-row style="margin-top: 15px">
                    <el-col>
                        <el-button type="primary" size="small" plain @click="handleAddRoles">添加角色</el-button>
                        <el-button type="primary" size="small" plain @click="handleRemoveRoles">移除角色</el-button>
                        <el-button type="primary" size="small" plain @click="handleImportRoles">导入角色</el-button>
                    </el-col>
                </el-row>
				<!-- 表格-start -->
				<el-row style="margin-top: 15px">
					<hot-table ref="rolesTableRef" :data-source="rolesTableDataSource"
						:settings="rolesTableSettings" col-settings-key="rolesTable">
						<hot-column :has-tip="true" data="use_code" title="角色名称" width="150">
							<el-input-editor hot-editor data="use_code" />
						</hot-column>

						<hot-column :has-tip="true" data="user_name_cn" title="创建人" width="150">
							<el-input-editor hot-editor data="user_name_cn" />
						</hot-column>

						<hot-column :has-tip="true" data="user_name" title="创建时间" width="150">
							<el-input-editor hot-editor data="user_name" />
						</hot-column>
						<hot-column :has-tip="true" data="default_office" title="修改人" width="150">
							<el-input-editor hot-editor data="default_office" />
						</hot-column>
						<hot-column :has-tip="true" data="age" title="修改时间" date-format="yyyy-MM-DD HH:mm:ss" width="150">
							<el-input-editor hot-editor data="age" />
						</hot-column>
					</hot-table>
				</el-row>
			</el-col>
			<!-- 分页start -->
			<div class="pg_div">
				<el-pagination :current-page="pageConfig.currentPage" :layout="pageConfig.layout"
					:page-size="pageConfig.pageSize" :page-sizes="pageConfig.pageSizes" :total="pageConfig.total"
					@current-change="handleCurrentChange" @size-change="handleSizeChange" />
			</div>
			<!-- 分页end -->
		</el-form>
	</div>
</template>

<script>
	import { userMaintainFormRules } from "@/rules/systemRules";
	export default {
		data() {
			return {
				userMaintainForm: {
                    user_code: ''
                },
                userMaintainFormRules: {
                    ...userMaintainFormRules
                },
				// 分页
				pageConfig: {
					layout: 'total, sizes, prev, pager, next, jumper',
					total: 0,
					pageSize: 10,
					pagerCount: 10,
					currentPage: 1,
					pageSizes: [10, 20, 50, 100]
				},
				// currentPage 改变时会触发
				handleCurrentChange(val) {
					console.log(`当前页: ${val}`)
					this.pageConfig.currentPage = val
				},
				// 表格校验
				// 表格校验
				rolesTableRules: {},
				// 表格数据
				rolesTableDataSource: [],
				// 表格设置
				rolesTableSettings: {
					height: 360,
					stretchH: 'all', // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
					...this.$systemConfig.tableConfig

				},
                userTypeList: [
                    {
                        key: '0',
                        value: '业务员'
                    },
                    {
                        key: '1',
                        value: '客服/单证'
                    },
                    {
                        key: '2',
                        value: '财务'
                    },
                    {
                        key: '3',
                        value: '管理者'
                    }
                ],
                sexList: [
                    {
                        key: '0',
                        value: '男'
                    },
                    {
                        key: '1',
                        value: '女'
                    },
                ]
			};
		},
    async created() {

    },
		mounted() {
			let self = this
			// 监听外层容器div宽度的变化，做表格自适应
			self.resizeObserver = new ResizeObserver(entries => {
				self.$nextTick(() => {
					self.$refs.rolesTableRef.resizeTo(entries[0].target.clientWidth - 32)
				})
			})
			self.resizeObserver.observe(document.getElementById("userMaintainContainer"))
		},
		methods: {
			// 新增
            handleAdd() {
                this.$router.push({
                    path: '/system/usermaintain'
                })
            },
            // 保存
            handleSave() {

            },
            // 重置密码
            handleResetPwd() {

            },
            // 生效
            handleEnable() {

            },
            // 失效
            handleDisable() {

            },
            // 添加角色
            handleAddRoles() {

            },
            // 移除角色
            handleRemoveRoles() {

            },
            // 导入角色
            handleImportRoles() {

            },
            // pageSize 改变时会触发
            handleSizeChange(val) {
                console.log(`每页 ${val} 条`)
                this.pageConfig.pageSize = val
            },
            // currentPage 改变时会触发
            handleCurrentChange(val) {
                this.pageConfig.currentPage = val
            },
		}
	};
</script>

<style scoped lang="less">

</style>
